import React__default from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../Button/index.js';
import styles from 'ui-components/NotificationBar.scss';

var _excluded = ["text", "onClose", "icon", "iconPosition", "className", "closeBtnTitle", "CloseIcon", "CloseBtnClassName", "wrapperClassName"];
var DefaultCloseIcon = function DefaultCloseIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.2 4.8L4.8 19.2M19.2 19.2L4.8 4.8"
  })));
};
var NotificationBar = function NotificationBar(_ref2) {
  var _ref2$text = _ref2.text,
    text = _ref2$text === void 0 ? "" : _ref2$text,
    onClose = _ref2.onClose,
    icon = _ref2.icon,
    _ref2$iconPosition = _ref2.iconPosition,
    iconPosition = _ref2$iconPosition === void 0 ? "left" : _ref2$iconPosition,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    _ref2$closeBtnTitle = _ref2.closeBtnTitle,
    closeBtnTitle = _ref2$closeBtnTitle === void 0 ? "Close" : _ref2$closeBtnTitle,
    _ref2$CloseIcon = _ref2.CloseIcon,
    CloseIcon = _ref2$CloseIcon === void 0 ? DefaultCloseIcon : _ref2$CloseIcon,
    CloseBtnClassName = _ref2.CloseBtnClassName,
    wrapperClassName = _ref2.wrapperClassName,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.wrapper, wrapperClassName)
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    className: cn(styles.block, className)
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.content
  }, icon !== null && iconPosition === "left" && icon, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text
    },
    className: styles.text
  }), icon !== null && iconPosition === "right" && icon), /*#__PURE__*/React__default.createElement(Button, {
    type: "button",
    "aria-label": closeBtnTitle,
    className: styles.closeBtn,
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, {
    title: t("ICONS.CROSS"),
    className: cn(styles.icon, CloseBtnClassName)
  }))));
};

export { NotificationBar };
//# sourceMappingURL=index.js.map
